import React, { useContext } from 'react'
import './Cart.css'
import { StoreContext } from '../../context/StoreContex'

const Cart = () => {

  const { products,cartItems, food_list, removeFromCart ,getTotalCartAmount,checkOut } = useContext(StoreContext);
  
 
  return (
    <div className='cart'>
      <div className='cart-items'>
        <div className="cart-items-title">
          <p>Items</p>
          <p>Title</p>
          <p>Price</p>
          <p>Quantity</p>
          <p>Total</p>
          <p>Remove</p>
        </div>
        <br />
        <hr />
        {/* {
          food_list.map((item, index) => {
            if (cartItems[item._id] > 0) {
              return (
                <div>
                  <div className='cart-items-title cart-items-item'>
                    <img src={item.image} alt="" />
                    <p>{item.name}</p>
                    <p>${item.price}</p>
                    <p>{cartItems[item._id]}</p>
                    <p>${item.price * cartItems[item._id]}</p>
                    <p onClick={()=>removeFromCart(item._id)} className='cross'>X</p>
                  </div>
                  <hr />
                </div>
              )
            }
          })} */}
          {
  products.map((category) => {
    return category.items.map((item) => {
      if (cartItems[item._id] > 0) {
        return (
          <div key={item._id}>
            <div className="cart-items-title cart-items-item">
              <img src={item.image} alt={item.name} />
              <p>{item.item}</p>
              <p>${item.price}</p>
              <p>{cartItems[item._id]}</p>
              <p>${item.price * cartItems[item._id]}</p>
              <p
                onClick={() => removeFromCart(item._id)}
                className="cross"
              >
                X
              </p>
            </div>
            <hr />
          </div>
        );
      }
      return null; // Return null for items not in the cart
    });
  })
}

      </div>
      <div className='cart-bottom'>
        <div className='cart-total'>
           <h2>Cart Total</h2>
           <div>
            <div className="cart-total-details">
            <p>Subtotal</p>
            <p>${(getTotalCartAmount()).toFixed(2)}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <p>Delivery Fee</p>
              <p>${(getTotalCartAmount()===0?0:2).toFixed(2)}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <b>Total</b>
              <b>${(getTotalCartAmount()===0?0:getTotalCartAmount()+2).toFixed(2)}</b>
            </div>
           </div>
           <button onClick={()=>checkOut()}>Proceed To Checkout</button>
        </div>
        <div className="cart-promocode">
          <div>
            <p>If you Have a promo code, Enter it here</p>
            <div className='cart-promocode-input'>
              <input type="text" placeholder='promo code' />
              <button>Submit</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Cart